import { toast } from 'react-toastify';
import ErrorToast from './ErrorToast';
import SuccessToast from './SuccessToast';
import LightModeToast from './LightModeToast';
import DarkModeToast from './DarkModeToast';
import 'react-toastify/dist/ReactToastify.css';
import toastStyle from './Toasts.module.scss';

export const showError = (message = '', options = { autoClose: 5000, position: 'top-right' }) =>
  toast(<ErrorToast message={message} />, {
    className: toastStyle['custom-error-toast'],
    bodyClassName: toastStyle['custom-error-body-class-name'],
    progressClassName: toastStyle['custom-error-progress-class-name'],
    ...options,
  });

export const showSuccess = (
  message = '',
  options = { autoClose: 3000, position: 'bottom-center' }
) =>
  toast(<SuccessToast message={message} />, {
    className: toastStyle['custom-success-toast'],
    bodyClassName: toastStyle['custom-success-body-class-name'],
    progressClassName: toastStyle['custom-success-progress-class-name'],
    ...options,
  });

export const showLightMode = (
  message = '',
  options = { autoClose: 2500, position: 'bottom-center' }
) =>
  toast(<LightModeToast message={message} />, {
    className: toastStyle['custom-light-mode-toast'],
    bodyClassName: toastStyle['custom-light-mode-body-class-name'],
    progressClassName: toastStyle['custom-light-mode-progress-class-name'],
    ...options,
  });

export const showDarkMode = (
  message = '',
  options = { autoClose: 2500, position: 'bottom-center' }
) =>
  toast(<DarkModeToast message={message} />, {
    className: toastStyle['custom-dark-mode-toast'],
    bodyClassName: toastStyle['custom-dark-mode-body-class-name'],
    progressClassName: toastStyle['custom-dark-mode-progress-class-name'],
    ...options,
  });
